function shouldMirrorLocalHostname(hostname) {
  return hostname === 'localhost' || hostname === '127.0.0.1';
}

function isMarketplacePreviewHostname(hostname) {
  return /^marketplace-dev\.[a-z0-9.-]+\.nip\.io$/i.test(String(hostname || '').trim());
}

export function normalizeApiBaseUrl(value) {
  const base = String(value || 'http://localhost:3000').replace(/\/+$/, '');
  if (base.endsWith('/api/v1')) {
    return base;
  }
  return `${base}/api/v1`;
}

export function resolveApiBaseUrl(value, currentHostname) {
  const normalized = normalizeApiBaseUrl(value);
  const hostname = String(currentHostname || '').trim();

  if (!hostname) {
    return normalized;
  }

  // The public marketplace preview and its authenticated seller flow share the
  // dev database through the same-origin nginx gateway. Never let a production
  // VITE_API_URL make a preview browse or mutate production marketplace data.
  if (isMarketplacePreviewHostname(hostname)) {
    return `http://${hostname}/api/v1`;
  }

  const url = new URL(normalized);
  if (shouldMirrorLocalHostname(url.hostname) && shouldMirrorLocalHostname(hostname)) {
    url.hostname = hostname;
  }

  return url.toString().replace(/\/+$/, '');
}
